import styles from "./StepHeader.module.css";

interface StepHeaderProps {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Render the title with the display serif font (default true). */
  display?: boolean;
}

/** Gold kicker label + display heading — the recurring section header idiom. */
export function StepHeader({ kicker, title, subtitle, display = true }: StepHeaderProps) {
  return (
    <header className={styles.head}>
      {kicker && <p className="ap-kicker">{kicker}</p>}
      <h2 className={display ? `ap-display ${styles.title}` : styles.titlePlain}>{title}</h2>
      {subtitle && <p className={styles.sub}>{subtitle}</p>}
    </header>
  );
}
